import Vue from 'vue';
import VueRouter from 'vue-router';
//import {KYC} from '../../embarkArtifacts/contracts';
import {store} from '../store/index.js';

//import {KYC} from "../../embarkArtifacts/contracts";
import PersonalDetailsGov from "../components/PersonalDetailsGov.vue"

Vue.use (VueRouter);


const router = new VueRouter ({
 

  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import ('../views/Login.vue'),
      // beforeEnter: (to, from, next) => {
      //   if (localStorage.getItem ('loggedIn') == false) {
      //     next ();
      //   } else {
      //     next ('/');
      //   }
      // },
    },
   
    {
      path: '/history',
      name: 'history',
      component: () => import ('../views/HistoryView.vue'),
       beforeEnter: async (to, from, next) => {
        
        let address = $cookies.get('address')
        let done = await store.state.KYC.isParty (address).call ();
        if (done == true) {
          next ();
        } else {
          next ('/');
        }
      },
    },
    {
      path: '/kyc/:partyName?',
      name: 'kycApplication',
      component: () => import ('../views/KYCForm.vue'),
    
      beforeEnter: async (to, from, next) => {
        let address = $cookies.get('address')
        let owner1=await store.state.KYC.Owner().call();
      
        let done = await store.state.KYC.KYCDone (address).call ();
        if (done == false && address!=owner1) {
          next ();
        }else{
          next('/')
        }
      },
     
    },
    {
      path: '/kycUpdate',
      name: 'kycUpdate',
      component: () => import ('../views/KYCUpdate.vue'),
     
      beforeEnter: async (to, from, next) => {
        let address = $cookies.get('address')
        let done = await store.state.KYC.KYCDone (address).call ();
        if (done == true) {
          next ();
        }else{
          next('/')
        }
      },
    },
    {
      path: '/kycDone',
      name: 'kycDone',
      component: () => import ('../views/KYCDone.vue'),
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        let address =$cookies.get('address')
        let done = await store.state.KYC.KYCDone (address).call ();
        if (done == false) {
          next ();
        }else{
          next('/')
        }
      },
      
    },
    {
      path: '/kycUpdateDone',
      name: 'kycUpdateDone',
      component: () => import ('../views/KYCUpdateDone.vue'),
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        let address = $cookies.get('address')
        
        let done = await store.state.KYC.KYCDone (address).call ();
        if (done == true) {
          next ();
        }else{
          next('/')
        }
      },
      
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import ('../views/Profile.vue'),
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        let address = $cookies.get('address');
        // let done = await store.state.KYC.KYCDone (address).call();
        let blocked= await store.state.KYC.blocked(address).call();
        if (!blocked) {
          next ();
        } else {
          next ('/');
        }
      },
    },

    {
      path: '/payId/:payId',
      name: 'payId',
      component: () => import ('../views/PayId.vue'),
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        let address = $cookies.get('address');
        let done = await store.state.KYC.KYCDone (address).call();
        let blocked= await store.state.KYC.blocked(address).call();
        let isUser=await store.state.PayID.isUser(address).call();
        if (!blocked && done && isUser) {
          next ();
        } else {
          next ('/');
        }
      },
    },
    {
      path: '/userData/:userAddress',
      name: 'userData',
     // component: () => import ('../views/PersonalDetailsGov.vue'),
     component:PersonalDetailsGov,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
       
        
        let address = $cookies.get('address')
        let done = await store.state.KYC.isGov (address).call ();
        if (done == true) {
          next ();
        } else {
          next ('/');
        }
      },
    },
    {
      path: '/userDataParty/:userAddress',
      name: 'userDataParty',
      component: () => import ('../views/PersonalDetailsParty.vue'),
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        let address =  $cookies.get('address')
        let done = await store.state.KYC.isParty (address).call ();
        if (done == true) {
          next ();
        } else {
          next ('/');
        }
      },
    },

    {
      path: '/',
      name: 'home',
      component: () => import ('../components/Home.vue'),
    
      
    },
    {
      path: '/404',
      name: '404',
      component: () => import ('../views/404.vue'),
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
});

router.beforeEach(async(to,from,next)=>{
 
 
 
 
  

// router.beforeEach(async (to,from,next)=>{
//   store.dispatch('setContract')
// })
// router.beforeEach ((to, from, next) => {
 
  
 try{
  if(store.state.KYC==undefined){
    store.state.loading=true;
    await store.dispatch('setContract')
    }
  let address=$cookies.get('address');

  // if (to.matched.some(record => record.meta.requiresAuth)) {
    
  //   if (pass==null && pk==null) {
  //     next({
  //       path: '/login',
       
  //     })
  //   } else {
  //     next()
  //   }
  // }
  // else {
  //   if (to.path=="/login" && pass==null && pk==null) {
  //     next()
  //   } else {
  //     next('/')
  //   }
  // }
  
 
  
 
  
  if(to.path!=="/login"){
  if(address==null && (localStorage.wallet==null || localStorage.wallet_web3==null)){
    
    next('/login')
  }else if(address && (localStorage.wallet || localStorage.wallet_web3)){
   
    next({
        params: { nextUrl: '/' }})
  }else{
    next("/login");
  }
}else if(to.path=="/login" && (address==null ||(localStorage.wallet == null && localStorage.wallet_web3==null)))  {
  
  next()
}else{
  next('/')
}
  
}
catch(err){
  console.log(err)
}

})

export default router;
